import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["bus"];
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error Not typed yet
import { getCanUseAIGeneratedContent } from 'ContentEditorUI/redux/selectors/featureSelectors';
// @ts-expect-error Not typed yet
import { getCanUseCopilotCollaboration } from 'ContentEditorUI/redux/selectors/featureSelectors';
// @ts-expect-error Not typed yet
import { getApiClient } from 'interframe/proxy/api-request-proxy';
import { HttpClientContext } from 'ui-coaching-tips/api/HttpClientContext';
import CommandCoachingTips from 'content-assistance-lib/buttons/CommandCoachingTips';
import { jsx as _jsx } from "react/jsx-runtime";
const FIRST_RICH_TEXT_SELECTOR = '.hs_cos_wrapper_type_rich_text:first-of-type';
const CoachingTipsContainer = _ref => {
  let {
      bus
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const canUseAIGeneratedContent = useSelector(getCanUseAIGeneratedContent);
  const canUseCopilotCollaboration = useSelector(getCanUseCopilotCollaboration);
  const httpClient = useMemo(() => getApiClient(bus), [bus]);

  // @ts-expect-error accessing global var on window
  if (!canUseAIGeneratedContent || window.SELENIUM_IS_RUNNING) {
    return null;
  }

  // Hide CA coaching tips if using Copilot collab (for now?)
  if (canUseCopilotCollaboration) {
    return null;
  }
  return /*#__PURE__*/_jsx(HttpClientContext.Provider, {
    value: httpClient,
    children: /*#__PURE__*/_jsx(CommandCoachingTips, Object.assign({}, rest, {
      attachTo: FIRST_RICH_TEXT_SELECTOR,
      placement: "top right"
      // Only pages and blog use rich text configs and they both have slash commands
      ,
      hasSlashCommands: true
    }))
  });
};
export default CoachingTipsContainer;